import type { Section } from "../../  config/sectionsConfig";
interface SettingsAccordionProps {
  sections: Section[];
}

export function SettingsAccordion({ sections }: SettingsAccordionProps) {
  return (
    <div className="space-y-3">
      {sections.map((section, index) => (
        <div key={section.id} className="">

          {/* Header */}
          <div
            className="w-full px-4 py-3 text-left rounded-md bg-[#EDEFF6] text-[#00032A]"
          >
            <p className="font-medium mb-2">{section.title}</p>
            {section.description && (
              <p className="text-sm text-[#4F4F4F]">
                {section.description}
              </p>
            )}
          </div>


          <div className="pt-4 pb-4 lg:p-4 border-t text-sm text-gray-600 bg-white">
            {section.content}
          </div>


          {index < sections.length - 1 && <hr className="border-gray-200" />}
        </div>
      ))}
    </div>
  );
}


